// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:32:04

export default {
  "id": "soccer-euro-cup-2025",
  "slug": "soccer-euro-cup-2025",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/608b965aa08644ceabb138d27d8661af-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/608b965aa08644ceabb138d27d8661af/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Soccer Euro Cup 2025",
      "description": "Can you hear the deafening cheers of a mighty crowd? Get pumped for the Soccer Euro Cup 2025!\n\nPick your favorite country to represent and get ready for kickoff. Do your best to kick or headbutt the ball into your opponent's goal!\n\nHow many did you manage to score? Play now, and let's find out!",
      "instructions": "For Player 1, use the WASD keys to move around and B to kick. For Player 2, use the arrow keys to move around and K to kick. Try to score the most goals within the time limit.",
      "genres": [
        "Football"
      ],
      "tags": [
        "2players",
        "sport"
      ]
    },
    "zh-CN": {
      "title": "足球欧洲杯2025",
      "description": "你能听到震耳欲聋的欢呼声吗？为2025年欧洲杯足球赛激情预热！\n\n选择你最喜欢的国家代表，准备开赛。尽你所能将球踢或头球攻入对方球门！\n\n你一共进了多少球？现在就玩起来，让我们揭晓答案！",
      "instructions": "玩家1使用WASD键移动，B键踢球。玩家2使用方向键移动，K键踢球。在时间限制内尽可能多得分。",
      "genres": [
        "足球"
      ],
      "tags": [
        "2人",
        "运动"
      ]
    },
    "zh-TW": {
      "title": "足球歐洲盃2025",
      "description": "你能聽到震耳欲聾的歡呼聲嗎？為2025年足球歐洲杯熱血沸騰！\n\n選擇你喜愛的國家來代表，準備開賽。盡你所能將球踢進對方的球門！\n\n你成功射入了多少分？現在就開始遊戲，讓我們一探究竟！",
      "instructions": "對於玩家1，使用WASD鍵來移動，並使用B鍵來踢球。對於玩家2，使用方向鍵來移動，並使用K鍵來踢球。盡量在時間限制內射入最多的進球。",
      "genres": [
        "足球"
      ],
      "tags": [
        "兩人遊戲",
        "運動類"
      ]
    },
    "zh-HK": {
      "title": "足球歐洲盃2025",
      "description": "你能聽到震耳欲聾的歡呼聲嗎？為2025年足球歐洲杯熱血沸騰！\n\n選擇你喜愛的國家代表，準備開賽。盡你所能將球踢進對方的球門！\n\n你成功射入多少分？立即開始遊戲，一探究竟！",
      "instructions": "玩家1：使用WASD鍵移動，按B鍵踢球。\n玩家2：使用方向鍵移動，按K鍵踢球。\n嘗試在時間限制內射入最多進球。",
      "genres": [
        "足球"
      ],
      "tags": [
        "2人",
        "運動"
      ]
    },
    "ja": {
      "title": "サッカーエウロカップ2025",
      "description": "deafening cheers of a mighty crowd - 力強い群衆の圧倒的な歓声\n Soccer Euro Cup 2025 - サッカーエウロカップ2025\n Pick your favorite country to represent - あなたの好きな国を選んで代表しましょう\n get ready for kickoff - 開幕戦に備えましょう\n Do your best to kick or headbutt the ball into your opponent's goal! - 尽全力でボールを相手のゴールに蹴り入れたり頭突きにしましょう！\n How many did you manage to score? - あなたはいくつスコアを獲得したか？\n Play now, and let's find out! - 今すぐ遊んでみて、結果を見てみましょう！",
      "instructions": "プレイヤー1はWASDキーを使用して移動し、Bキーでキックしてください。プレイヤー2は矢印キーを使用して移動し、Kキーでキックしてください。時間内にできるだけ多くのゴールを目指してください。",
      "genres": [
        "フットボール"
      ],
      "tags": [
        "2プレイヤー",
        "スポーツ"
      ]
    },
    "ko": {
      "title": "축구 유로컵 2025",
      "description": "대단한 관중들의 울부짖는 환호를 들려요? 2025년 축구 유로컵에 설레심어하세요!\n\n자신의 좋아하는 국가를 선택해 출발을 기다리세요. 상대의 골대에 공을 차거나 머리로 차고 만점을 맞추세요!\n\n얼마나 많은 골을 득점했는지 확인해보세요! 지금 즉시 플레이하고 결과를 알아보죠!",
      "instructions": "플레이어 1은 WASD 키를 사용하여 움직이고 B 키를 사용하여 킥을 치세요. 플레이어 2는 방향 키를 사용하여 움직이고 K 키를 사용하여 킥을 치세요. 시간 내에 최대한의 골을 넣으세요.",
      "genres": [
        "축구"
      ],
      "tags": [
        "2플레이어",
        "스포츠"
      ]
    },
    "fr": {
      "title": "Coupe d'Europe de football 2025",
      "description": "Peux-tu entendre les acclamations assourdissantes d'une foule puissante ? Met-toi en condition pour la Coupe d'Europe de Football 2025 !\n\nChoisis ton pays préféré pour le représenter et prépare-toi au coup d'envoi. Fais de ton mieux pour marquer ou frapper la balle dans le but adverse !\n\nCombien as-tu réussi à marquer ? Joue maintenant, et découvrons-le !",
      "instructions": "Pour le joueur 1, utilisez les touches WASD pour vous déplacer et B pour frapper. Pour le joueur 2, utilisez les flèches pour vous déplacer et K pour frapper. Essayez de marquer le plus de buts dans le temps imparti.",
      "genres": [
        "Football"
      ],
      "tags": [
        "2 joueurs",
        "sport"
      ]
    }
  }
};
